import { WarningOutlined } from "@ant-design/icons";

interface IProps {
  message: string;
}

export default function ErrorMessage({
  message,
}: IProps) {
  return (
    <div
      style={{
        background: "#fff6f6",
        padding: "2px 12px",
        borderRadius: 4,
        width: "fit-content",
        maxWidth: "100%",
        border: "1px solid #ff4d4f",
        marginTop: 4,
      }}
    >
      <WarningOutlined
        style={{
          marginRight: 8,
          color: "#ff4d4f"
        }}
      />

      <span
        style={{
          color: "#ff4d4f",
        }}
      >
        {message}
      </span>
    </div>
  )
}
